import { useAnnotationTypesStore } from "~/composables/useAnnotationTypesStore";
import { AnnotationTypes } from "~/types/enums/AnnotationTypes.enum";
export const useAnnotationType = (annotationType: AnnotationTypes) => {
  return useAnnotationTypesStore().annotationTypeFromType(annotationType);
};
